/* eslint-disable @next/next/no-img-element */
"use client";

import config from "@/config";
import { authClient } from "@/lib/client/betterauth/auth-client";
import { useRouter } from "next/navigation";
import { Button } from "./ui/button";
import { useT } from "@/app/i18n/client";

// A simple button to sign in with our providers (Google & Magic Links).
// It automatically redirects user to callbackUrl (config.auth.callbackUrl) after login, which is normally a private page for users to manage their accounts.
// If the user is already logged in, it will show their profile picture & redirect them to callbackUrl immediately.
const ButtonSignin = ({ text }: { text?: string }) => {
  const router = useRouter();
  const { data: session } = authClient.useSession();
  const { t } = useT("landing", { keyPrefix: "nav_bar" });
  const buttonText = text || t("login_button");

  const handleClick = () => {
    if (session?.user) {
      router.push(config.auth.callbackUrl);
    } else {
      router.push("/sign-in");
    }
  };

  // if (status === "authenticated") {
  //   return (
  //     <Button
  //       asChild
  //       variant="outline"
  //       size="lg"
  //       className="bg-gray-800 text-white hover:bg-gray-700 hover:text-white"
  //     >
  //       <Link
  //         href={config.auth.callbackUrl}
  //         className="flex items-center gap-2"
  //       >
  //         <Avatar className="size-6">
  //           <AvatarImage
  //             src={session.user?.image}
  //             alt={session.user?.name || "Account"}
  //             referrerPolicy="no-referrer"
  //           />
  //           <AvatarFallback>
  //             {session.user?.name?.charAt(0) || session.user?.email?.charAt(0)}
  //           </AvatarFallback>
  //         </Avatar>
  //         <span>{session.user?.name || session.user?.email || "Account"}</span>
  //       </Link>
  //     </Button>
  //   );
  // }

  return (
    <Button onClick={handleClick} size="lg" className="" variant="outline">
      {buttonText}
    </Button>
  );
};

export default ButtonSignin;
